export const PARTICULARS_MOBILE_OPERATOR_REQUEST = 'PARTICULARS_MOBILE_OPERATOR_REQUEST';
export const PARTICULARS_MOBILE_OPERATOR_SUCCESS = 'PARTICULARS_MOBILE_OPERATOR_SUCCESS';
export const PARTICULARS_MOBILE_OPERATOR_ERROR = 'PARTICULARS_MOBILE_OPERATOR_ERROR';

export const CHECK_NUMBER_PORT_REQUEST = 'CHECK_NUMBER_PORT_REQUEST';
export const CHECK_NUMBER_PORT_SUCCESS = 'CHECK_NUMBER_PORT_SUCCESS';
export const CHECK_NUMBER_PORT_ERROR = 'CHECK_NUMBER_PORT_ERROR';

export const RESET_NUMBER_PORT = 'RESET_NUMBER_PORT';
